/// <summary>
/// This visual provides the main shell with top-menu and sub-menu for user notifications.<br/>
/// Content is loaded dynamically into the content area based on the selected sub-menu type.<br/>
/// </summary>
/// <remarks>
/// Author: AFU<br/>
/// Date: 29.10.2025<br/>
/// Copyright ©: EUDT GmbH 2024 <br/>
/// Version-History:<br/>
/// **********************************************************************<br/>
/// *** v2.0.0 - 22.06.2026                                            ***<br/>
/// **********************************************************************<br/>
/// * - split into Center (shell) and CenterContent (list content)       *<br/>
/// **********************************************************************<br/>
/// *** v1.1.0 - 22.06.2026                                            ***<br/>
/// **********************************************************************<br/>
/// * - replaced types optionbox with a horizontal button sub-menu       *<br/>
/// **********************************************************************<br/>
/// *** v1.0.0 - 17.11.2025                                            ***<br/>
/// **********************************************************************<br/>
/// * - generates basic functionality                                    *<br/>
/// **********************************************************************<br/>
jQuery.widget("bluaul.UserNotificationCenter", jQuery.common.vcBaseV4, {

    myData: {
        types: null,
        projects: null,
    },

    myStatus: {
        selectedTypeId: 1, // default is validation (first type)
        dateRange: { from: moment().add(-7, "days").format('DD.MM.YYYY'), to: moment().format('DD.MM.YYYY') },
    },

    _create: function () {
        this._createVisual(398);
        this._super();
    },

    _initHTML: function () {
        var me = this;
        try {
            me._setRoot(".vc-user-notification-center");

            var rawTypes = JSON.parse(me.specific.lstTypes);

            // we resort the types 
            var first = rawTypes.filter(function (x) { return x.Key === 1; });
            var second = rawTypes.filter(function (x) { return x.Key === 12; });
            var secondToLast = rawTypes.filter(function (x) { return x.Key === 2; });
            var last = rawTypes.filter(function (x) { return x.Key === 6; });
            var rest = rawTypes.filter(function (x) { return x.Key !== 1 && x.Key !== 12 && x.Key !== 2 && x.Key !== 6; });

            me.myData.types = first.concat(second, rest, secondToLast, last);
            me.myData.projects = JSON.parse(me.specific.lstProjects);

            if (me.myData.types.length > 0) { me.myStatus.selectedTypeId = me.myData.types[0].Key; }

            //get the default time range
            me.myStatus.dateRange.from = moment().add(me.specific.interval * -1, "days").format('DD.MM.YYYY');

            me._buildHtml();
            me._setHeightsAndWidths();

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _initEvents: function () {
        var me = this;
        try {

            me._initStructure();

            //load the default content
            me._loadContent();

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _buildHtml: function () {
        /// <summary>
        /// This function builds the html structure with top-menu, sub-menu and content area
        /// </summary>
        var me = this;
        try {
            me.myHtml = {
                topMenu: {}, subMenu: {}, content: null
            };

            //top menu
            var obj = me.myHtml.topMenu;
            obj.wrapper = me._setWrapper("top-menu", "vc-grid-margin-bottom");
            obj.reload = me._setMainButton("reload", me.specific.resources.iconReload, me.specific.resources.reload).addClass("active");
            obj.date = me._setObj("date", "optionbox vc-grid-2col vc-grid-margin-right  float-box");


            obj.projects = me._setObj("types", "optionbox vc-grid-2col vc-grid-margin-right  float-box");


            obj.showAll = me._setObj("user", "optionbox vc-grid-2col float-box");

            //project list
            obj.ddlProjects = me._setFilterDropDown("ddl-projects", "", [{ Key: -1, Value: me.specific.resources.selectAll }], me.myData.projects, me.settings.blid);
           
            obj.projects.vcOptionBox({
                caption: me.resources.selection, items: [{ button: me.specific.resources.projects, clickable: true, isList: true, content: obj.ddlProjects }]
            });
            //hide the dropdown if we only have one project
            if (me.myData.projects.length == 1) { obj.projects.hide(); }

            let divShowAll = me._setObj("", "vc-").css("margin-top", "16px");
            obj.chbShowAll = me._setInput("chb-show-all", "").attr("type", "checkbox").prop("name", "chb-show-all").css("margin-right", "3px");
            let lblShowAll = $("<label>").attr("for", "chb-show-all").text(me.specific.resources.showAll);
            divShowAll.append(obj.chbShowAll, lblShowAll);
            obj.showAll.vcOptionBox({
                caption: me.resources.selection, items: [{ button: me.specific.resources.users, clickable: true, isList: false, content: divShowAll }]
            });

            //show the checkbox only for admins
            if (!me.specific.isAdmin) { obj.showAll.hide(); }

            obj.wrapper.append(obj.reload, obj.date, obj.projects, obj.showAll);

            //sub menu - horizontal type button bar
            obj = me.myHtml.subMenu;
            obj.wrapper = me._setWrapper("sub-menu", "vc-grid-margin-bottom");

            //set the start unc type - default start with validation
          
            me.myStatus.selectedTypeId = me.specific.uncTypeId != -1 ? me.specific.uncTypeId : 1;


            $.each(me.myData.types, function (index) {
                var isActiveClass = (this.Key == me.myStatus.selectedTypeId) ? "button-toggle-active " : "";
                var btn = me._setObj("", "button-toggle " + isActiveClass).data("typeid", this.Key).data("basename", this.Value).html(this.Value);
                // no wrap the text in the button to prevent it from breaking into multiple lines
                btn.css("white-space", "nowrap");
                obj.wrapper.append(btn.button());
            });

           




            //content area - dynamic content gets loaded here
            me.myHtml.content = me._setObj("content", "vc-content");

            me.myRoot.append(me.myHtml.topMenu.wrapper, me.myHtml.subMenu.wrapper, me.myHtml.content);

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _initStructure: function () {
        /// <summary>
        /// This function inits the top-menu and sub-menu events
        /// </summary>
        var me = this;
        try {

            //init vcDate
            me.myHtml.topMenu.date.vcDateBox({ mode: "Range", align: "center", interval: 1, langID: me.settings.userLangIDForCulture, defaultRange: me.myStatus.dateRange, callback: function (obj) { me.myStatus.dateRange = obj.dateRange; } });

            //init reload button
            me.myHtml.topMenu.reload.off("click").on("click", function () { me._loadContent(); });

            //init sub menu type buttons
            me.myHtml.subMenu.wrapper.find(".button-toggle").off("click").on("click", function () {
                me.myHtml.subMenu.wrapper.find(".button-toggle").removeClass("button-toggle-active");
                $(this).addClass("button-toggle-active");
                me.myStatus.selectedTypeId = $(this).data("typeid");
                me._loadContent();
            });

        } catch (e) { me._writeErr(e); }
    },

    _loadContent: function () {
        /// <summary>
        /// This function loads the content widget into the content area based on the selected sub-menu type
        /// </summary>
        var me = this;
        try {

          


            //destroy previous widget instance if exists
            try { me.myHtml.content.find("*").remove(); } catch (e) { }
            me.myHtml.content.empty();

            var contentH = me._getContentHeight();
            me.myHtml.content.css("height", contentH);

            // Get the dynamically selected project ID (will be -1 if "Select All" is selected)
            var selectedBlid = parseInt(me.myHtml.topMenu.ddlProjects.val(), 10);

            if (me.myStatus.selectedTypeId == 12) {
                me.myHtml.content.UserNotificationCommentList({
                    invokeType: "addVisualContent",
                    blid: me.settings.blid, // Keep the valid context BLID to ensure standard script registration
                    parameter: {
                        LoggerId: selectedBlid,
                        StartDate: me.myStatus.dateRange.from,
                        EndDate: me.myStatus.dateRange.to,
                        ShowAllUser: me.myHtml.topMenu.chbShowAll.prop("checked")
                    }
                });
            }
            else {

                //load the notification list content widget
                me.myHtml.content.UserNotificationCenterContent({
                    invokeType: "addVisualContent",
                    blid: selectedBlid, // Pass selected project ID or -1 for all projects
                    parameter: {
                        LoggerId: selectedBlid,
                        StartDate: me.myStatus.dateRange.from,
                        EndDate: me.myStatus.dateRange.to,
                        UncTypeId: me.myStatus.selectedTypeId,
                        ShowAllUser: me.myHtml.topMenu.chbShowAll.prop("checked"),
                        UncId: typeof (me.options.parameter.UncId) === 'undefined' ? -1 : me.options.parameter.UncId
                    }
                });
            }

            // listen for read-state changes from child widgets to refresh counts
            me.myHtml.content.off("notificationRead").on("notificationRead", function () {
                me._fetchCounts();
            });

            // fetch counts for all type buttons
            me._fetchCounts();

        } catch (e) { me._writeErr(e); }
    },

    // =====================================================================
    // COUNTS FOR SUB-MENU BUTTONS
    // =====================================================================

    _fetchCounts: function () {
        /// <summary>
        /// Fetches the entry count for each notification type and updates all sub-menu buttons.
        /// Uses the same filter settings (project, date range, showAll) as the content.
        /// </summary>
        var me = this;
        try {
            var selectedBlid = parseInt(me.myHtml.topMenu.ddlProjects.val(), 10);

            me.getData({
                TypeId: 1,
                LoggerId: selectedBlid,
                StartDate: me.myStatus.dateRange.from,
                EndDate: me.myStatus.dateRange.to,
                ShowAllUser: me.myHtml.topMenu.chbShowAll.prop("checked")
            }, function (result) {
                if (result !== null && typeof result === "object") {
                    me._updateButtonCounts(result);
                }
            });
        } catch (e) { me._writeErr(e); }
    },

    _updateButtonCounts: function (counts) {
        /// <summary>
        /// Updates each sub-menu button label with the entry count (like Ticket.js comment count).
        /// Displays count in parentheses; uses icon-color-error class if count > 0.
        /// </summary>
        var me = this;
        try {
            // Build a lookup from the array result: [ { Key: 1, Count: 5 }, ... ]
            var countMap = {};
            if (Array.isArray(counts)) {
                for (var i = 0; i < counts.length; i++) {
                    countMap[counts[i].Key] = counts[i].Count;
                }
            }

            me.myHtml.subMenu.wrapper.find(".button-toggle").each(function () {
                var btn = $(this);
                var typeId = btn.data("typeid");
                var baseName = btn.data("basename");
                var count = (typeof countMap[typeId] !== "undefined") ? parseInt(countMap[typeId], 10) || 0 : null;

                var labelHtml = baseName;

                if (count !== null) {
                    var spanClass = count > 0 ? "icon-color-error" : "";
                    labelHtml += " <span class='" + spanClass + "' style='margin-left: 3px;'>(" + count + ")</span>";
                }

                if (btn.hasClass("ui-button")) {
                    btn.button("option", "label", labelHtml);
                } else {
                    btn.html(labelHtml);
                }
            });
        } catch (e) { me._writeErr(e); }
    },

    _getContentHeight: function () {
        /// <summary>
        /// This function calculates the available height for the content area
        /// </summary>
        var me = this;
        try {
            var h = me._getVisualHeight();
            var menuH = me.myHtml.topMenu.wrapper.outerHeight(true) + me.myHtml.subMenu.wrapper.outerHeight(true);
            return h - menuH;
        } catch (e) { me._writeErr(e); return 400; }
    },

    _setHeightsAndWidths: function () {
        /// <summary>
        /// This function calculates and sets the height of the content area
        /// </summary>
        var me = this;
        try {
            me.myHtml.content.css("height", me._getContentHeight());
        } catch (e) { me._writeErr(e); }
    },

    specificInfoHandling: function (bError) {
        var me = this;
        try {
            if (bError) {
                me.myHtml.topMenu.wrapper.hide();
                me.myHtml.subMenu.wrapper.hide();
                me.myHtml.content.hide();
            }
            return true;
        } catch (e) {
            me.writeError(e); return false;
        }
    },

});